import http from '../http'
/**
 * get download S-parameter file list
 * @param {string} channelId
 * @param {string} interfaceId
 * @param {string} product
 * @param {string} projectId
 * @param {string} type
 */
export function getDownloadSParameterListAPI({ channelId, interfaceId, product, projectId, type }) {
  return http.post('/snp/download/list', {
    channelId,
    interfaceId,
    product,
    projectId,
    type
  })
}

/**
 * download S-parameter file
 * @param {string} snpUrl
 */
export function downloadSParameterAPI(snpUrl) {
  return http.post(`/snp/download`, snpUrl, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'text/plain'
    }
  })
}

/**
 * delete S-parameter file
 * @param {*} param0 
 * @returns 
 */
export function deleteSParameterAPI({ snpUrl }) {
  return http.post(`/snp/remove`, snpUrl, {
    headers: {
      'Content-Type': 'text/plain'
    }
  })
}

/**
 * transform S-parameter file
 * @param {Array} portMappings {newIndex, newName, originIndex, originalName}
 * @param {string} snpUrl
 * @param {string} targetFile
 * @param {string} format ma|ri|db
 */
export function transformSParameterAPI({ portMappings, snpUrl, targetFile, format }) {
  return http.post(`/snp/transform`, { portMappings, snpUrl, targetFile, format })
}
